import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useGetInfoQuery } from "../api/authQuery";
import { updateUnViewedNotification } from "../slices/notificationSlice";
import {
  TCustomerPermission,
  set,
  setCustomer,
} from "../slices/permissionSlice";

import { CustomerUserPermission } from "@/interfaces/customer-user.interface";
import { Permissions } from "@/interfaces/globals";
import { UserProps } from "@/interfaces/interfaces";
import { isCustomerPortal } from "@/lib/utils";
import { getToken } from "@/utils/helpers";

const CP_ALL_PERMISSION: TCustomerPermission[] = [
  {
    action: "READ",
    resource: Permissions.ALL,
    customer: "*",
  },
  {
    action: "WRITE",
    resource: Permissions.ALL,
    customer: "*",
  },
];
const CP_PERMISSIONS: TCustomerPermission[] = [
  {
    action: "READ",
    resource: Permissions.CP_DASHBOARD,
    customer: "*",
  },
  {
    action: "WRITE",
    resource: Permissions.CP_DASHBOARD,
    customer: "*",
  },
  {
    action: "READ",
    resource: Permissions.CP_USERMANAGEMENT,
    customer: "*",
  },
  {
    action: "WRITE",
    resource: Permissions.CP_USERMANAGEMENT,
    customer: "*",
  },
  {
    action: "READ",
    resource: Permissions.CP_PROJECTS,
    customer: "*",
  },
  {
    action: "WRITE",
    resource: Permissions.CP_PROJECTS,
    customer: "*",
  },
  {
    action: "READ",
    resource: Permissions.CP_INVOICES,
    customer: "*",
  },
  {
    action: "WRITE",
    resource: Permissions.CP_INVOICES,
    customer: "*",
  },
  {
    action: "READ",
    resource: Permissions.CP_WORKDOCKETS,
    customer: "*",
  },
  {
    action: "WRITE",
    resource: Permissions.CP_WORKDOCKETS,
    customer: "*",
  },
  {
    action: "READ",
    resource: Permissions.CP_WASTEMANAGEMENT,
    customer: "*",
  },
  {
    action: "WRITE",
    resource: Permissions.CP_WASTEMANAGEMENT,
    customer: "*",
  },
  {
    action: "READ",
    resource: Permissions.CP_WAREHOUSING,
    customer: "*",
  },
  {
    action: "WRITE",
    resource: Permissions.CP_WAREHOUSING,
    customer: "*",
  },
  {
    action: "READ",
    resource: Permissions.CP_SUPPORT,
    customer: "*",
  },
  {
    action: "WRITE",
    resource: Permissions.CP_SUPPORT,
    customer: "*",
  },
];

const getCPPermissions = (userData: UserProps): TCustomerPermission[] => {
  const permission = userData?.permissions;
  if (Array.isArray(permission)) {
    const hasAll = permission?.find(
      (p) => p.resource === "ALL" && p.action === "WRITE",
    );
    if (hasAll) {
      return CP_ALL_PERMISSION;
    }
  }

  if (!(permission as CustomerUserPermission)?.projectFinance) {
    return CP_PERMISSIONS.filter((p) => p.resource !== Permissions.CP_INVOICES);
  }

  return CP_PERMISSIONS;
};

export const PermissionsManager: () => null = () => {
  const { data } = useGetInfoQuery("_", {
    skip: isCustomerPortal || !getToken(),
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(set(data?.permissions || []));
    dispatch(updateUnViewedNotification(data?.unViewedNotifications ?? 0));
  }, [data, dispatch]);

  // for customer portal
  const userData: UserProps = JSON.parse(
    localStorage.getItem("userData") || "{}",
  );
  const permissions = getCPPermissions(userData);

  useEffect(() => {
    dispatch(setCustomer(permissions));
  }, [permissions, dispatch, userData]);

  return null;
};
